import { consolidatedPositionLiquidityEnum } from './constants';

export const isAssetLiquidity = (composition: string) => {
  return Object.keys(consolidatedPositionLiquidityEnum).includes(composition);
};
